import { api } from 'services/api/baseBackendAPI';

export const ehAppConfigApi = api.injectEndpoints({
  endpoints: (build) => ({
    getEHAppConfig: build.query({
      query: () => ({
        url: `funds/get-document-config`,
        method: 'GET',
      }),
      providesTags: ['EHAppConfig'],
      transformResponse: (response, meta, arg) => {
        return response.json_data;
      },
    }),
  }),
  overrideExisting: true,
});

export const { useGetEHAppConfigQuery } = ehAppConfigApi;
